import { css } from '@emotion/core';
import { subheading, actionButton } from './inspections-auctions.style';
export var onlineInspections = {
  name: "i3pbo",
  styles: "margin-bottom:24px;"
};
export var heading = subheading;
export var body = {
  name: "1qm1lh",
  styles: "margin-bottom:16px;"
};
export var button = /*#__PURE__*/css(actionButton, ";");